// Main.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import LoadingSpinner from '../../LoadingSpinner';
import { useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import './GamesMenu.css';

function GamesMenu() {

   
    const navigate = useNavigate(); // Initialize useNavigate
    const [notification, setNotification] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
  
    const [isArithmeticQuiz, setIsArithmeticQuiz] = useState(false);
    const [isMemoryGames, setIsMemoryGames] = useState(false);
    const [isPuzzles, setIsPuzzles] = useState(false);
   

    const toggleSection = (section) => {
        if (section === 'MemoryGames') {
          setIsMemoryGames(!isMemoryGames);
        } else if (section === 'Puzzles') {
          setIsPuzzles(!isPuzzles);     
        } else if (section === 'ArithmeticQuiz') {
          setIsArithmeticQuiz(!isArithmeticQuiz);
        }
      };
    
    
      const renderIcon = (section) => {
        if (section === 'ArithmeticQuiz') {
          return isArithmeticQuiz ? '' : '' /* or '-' : '+'*/;
        } else if (section === 'MemoryGames') {
          return isMemoryGames ? '' : '' /* or '-' : '+'*/;
        } else if (section === 'Puzzles') {
          return isPuzzles ? '' : '' /* or '-' : '+'*/;   
        }
      };

      const GeneralArithmeticQuiz = () => {
        navigate('/general-arithmetic-quiz');
      };

      const MemoryGames = () => {
        navigate('/memory-game');
      };

      const PuzzleGame = () => {
        navigate('/puzzle-game');
      };
    
      return (
        <div>
    
          <div className="parent-container">
            {isLoading && <LoadingSpinner />}
            {!isLoading && (
              <>
                <div className="settings-container">
              
            <div className="column-three-account-settings">
             
             
             
            </div>
                
                  
                  {/* User Info */}
                 

                  <div className="card">
                    <div onClick={() => toggleSection('MemoryGames')} className="card-title">
                      <Icon icon="arcticons:memory-zone" color="black" width="40" height="40" style={{ marginRight: '10px' }} />
                      Memory Games {renderIcon('MemoryGames')}
                    </div>
                    {isMemoryGames && (
                      <>
                      
                       
                        <p>
                        <button onClick={MemoryGames} >Play Memory Game</button>
                        </p>
                      </>
                    )}
                  </div>

                  <div className="card">
                    <div onClick={() => toggleSection('Puzzles')} className="card-title">
                      <Icon icon="fluent:puzzle-cube-28-filled" color="black" width="40" height="40" style={{ marginRight: '10px' }} />
                      Puzzle Games {renderIcon('Puzzles')}
                    </div>
                    {isPuzzles && (
                      <>
                      
                       
                        <p>
                        <button onClick={PuzzleGame} >Play Puzzle Game</button>
                        </p>
                      </>
                    )}
                  </div>
    
                 
                 <div className="card">
                    <div onClick={() => toggleSection('ArithmeticQuiz')} className="card-title">
                      <Icon icon="mynaui:math-square-solid" color="black" width="40" height="40" style={{ marginRight: '10px' }} />
                      Arithmetic Quiz {renderIcon('ArithmeticQuiz')} 
                    </div>
                    {isArithmeticQuiz && (
                      <>

                      <p>
                        <button onClick={GeneralArithmeticQuiz} >Play Arithmetic Quiz</button>
                        </p>
                      </>
                    )}
                  </div> 
                 
                  
                </div>
              </>
            )}
            
          </div>
          
        </div>
      );
}

export default GamesMenu;
